<template>
	<router-view />
</template>

<style lang="scss">
@import "~@hakosalo/hakolib/dist/hakoLib.css";
@import "~quill/dist/quill.snow.css";

body {
	min-height: 100vh;
	background-color: #f9f9f9;
}

.ql-editor {
	font-family: "Roboto", sans-serif;

	blockquote {
		border-left: 4px solid #ccc;
		padding-left: 16px;
	}
}
</style>
